export default "__VITE_ASSET__CmuaQnPP__"